module.exports = __webpack_public_path__ + "img/close_focused_pressed.ef9d8bde.png";